import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { usePacienteRadiologia } from '../hooks/usePacienteRadiologia';

import { Empty, Error, Forbidden, Loader, ModalContainer, MultiTextInputPreview, PrimaryButton, TextInputPreview } from '../../../components';
import { DetalleLabRadModal } from '../../Modals/DetalleLabRad';

import styles from '../PacienteConsulta.module.css';

export const RadiologiaPrevio = ({ id, editar, setRadiologiaActual }) => {

  const { permisos } = useSelector(state => state.auth);

  const { pacienteRadiologiaQuery: { isLoading, isError, data: radiologias } } = usePacienteRadiologia(id);

  const [radiologiaActiva, setRadiologiaActiva] = useState(null);

  const [statusDetallesModal, setStatusDetallesModal] = useState(false);

  const showDetallesModal = () => {
    setStatusDetallesModal(true);
  }

  const hideDetallesModal = () => {
    setStatusDetallesModal(false);
  }

  const handleDetalles = (rad) => {
    setRadiologiaActiva(rad);
    showDetallesModal();
  }

  const handleEditar = (rad) => {
    setRadiologiaActual(rad);
    editar();
  }
  
  return (permisos.radiologiaRead) ? (
    <>
    {(isLoading)
      ? <Loader />
      : <>
          {(isError)
            ? <Error />
            : <>
              {(radiologias.length > 0)
                ? radiologias.map((rad, index) => <div key={rad._id}>
                  <div className="row">
                    <div className="col">
                      <TextInputPreview
                          label="Fecha"
                          name="fecha"
                          value={rad.fechaFormato}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <MultiTextInputPreview
                        borders={false}
                        label="Estudios"
                        name="estudios"
                        values={rad.estudios}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <TextInputPreview
                          label="Comentarios"
                          marginBottom={false}
                          name="cometarios"
                          value={(rad.comentarios !== '') ? rad.comentarios : '-'}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                    </div>
                    <div className="col-md-6">
                      <div className="row">
                        <div className="col">
                          <PrimaryButton
                            block={true}
                            inverse={true}
                            marginTop={false}
                            onClick={() => handleDetalles(rad)}
                            text='Ver Detalles'
                            type='button'
                          />
                        </div>
                        <div className="col">
                          <PrimaryButton
                            block={true}
                            marginTop={false}
                            onClick={() => handleEditar(rad)}
                            text='Editar'
                            type='button'
                            />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.hrLabRad}></div>
                </div>)
                : <Empty />}
              <ModalContainer
                state={ statusDetallesModal }
                hide={ hideDetallesModal }
                content={ <DetalleLabRadModal hide={ hideDetallesModal } data={(radiologiaActiva !== null) ? radiologiaActiva : {}} /> }
              />
            </>
          }
      </>
    }
    </>
  ) : <div className='mt-2'><Forbidden /></div>
}

RadiologiaPrevio.propTypes = {
  id: PropTypes.string.isRequired,
  editar: PropTypes.func.isRequired,
  setRadiologiaActual: PropTypes.func.isRequired,
}